/**
 * Class for fetching coordinates for the city/town selected by user on welcome survey
 * @class GeoLocationClient
 */
class GeoLocationClient {
  geocoder: any = undefined;
  service: any = undefined;

  constructor() {
    if (window?.google?.maps?.places && window?.google?.maps?.Geocoder) {
      this.geocoder = new window.google.maps.Geocoder();
      this.service = new window.google.maps.places.AutocompleteService(null);
    }
  }

  private getLatLng = (locationID: number, cb: Function) => {
    this.geocoder.geocode(
      { placeId: locationID },
      (results: any, status: string) => {
        cb(results, status);
      },
    );
  };

  private _fetchCoordsWithPlaceId = async (
    googleData: any,
    responseCallback: Function,
  ) => {
    if (googleData) {
      this.getLatLng(googleData.place_id, (results: any) => {
        const latitude = results[0].geometry.location.lat();
        const longitude = results[0].geometry.location.lng();
        const locationName = results[0].formatted_address;
        responseCallback({
          latitude,
          longitude,
          locationName,
        });
      });
    } else {
      responseCallback(null);
    }
  };

  private _fetchPlaceIdForCity = async (
    cityName: string,
    responseCallback: Function,
  ) => {
    if (this.service.getPlacePredictions) {
      this.service.getPlacePredictions(
        {
          componentRestrictions: {
            country: 'us',
          },
          input: cityName,
        },
        (predictions: any) => {
          if (predictions && predictions.length) {
            this._fetchCoordsWithPlaceId(predictions[0], responseCallback);
          } else {
            responseCallback(null);
          }
        },
      );
    } else {
      responseCallback(null);
    }
  };

  fetchCoordsForCity = (cityName: string, responseCallback: Function) => {
    try {
      this._fetchPlaceIdForCity(cityName, responseCallback);
    } catch (error) {
      throw new Error(`Something went wrong in GeoLocationClient ${error}`);
    }
  };
}

export default GeoLocationClient;
